export default "__VITE_ASSET__DgADoqGj__"